import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Site } from '../../models/Site';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class SiteProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.assetApi + '/api/v1/site';

  getSites(): Observable<ApiResponse<Site[]>> {
    return this.httpClient.get<ApiResponse<Site[]>>(`${this.baseUrl}/all`);
  }

  upsertSite(site: Site): Observable<ApiResponse<Site>> {
    return this.httpClient.post<ApiResponse<Site>>(`${this.baseUrl}`, site);
  }
}
